import React from "react";
import { RegisterTemplatePage } from "../components/templates/RegisterTemplatePage";

export const RegisterPage = () => <RegisterTemplatePage />;
